import styled from 'styled-components'

import { ControlsContainer } from '@/components/VideoPlayer/styles'

export const StyledImageViewer = styled.img`
  position: relative;
  height: 1080px;
  width: 1920px;
  object-fit: contain;
  background: ${(props) => props.theme.colors.player.background};
`
export const HtmlWidgetViewer = styled.div`
  position: relative;
  height: 1080px;
  width: 1920px;
  background: ${(props) => props.theme.colors.player.background};
`
export const StyledControlsContainer = styled.div<{
  $inFront: boolean
}>`
  position: absolute;
  top: 0;
  height: 1080px;
  width: 1920px;
  ${(props) => props.$inFront && `z-index: 1;`}
`
export const ImageViewerControlsContainer = styled(ControlsContainer)`
  flex-direction: column;
  justify-content: space-between;
`
